/**
 * La URL del backend. Fuente única.
 *
 * Estaba declarada a mano en 16 archivos y no todas decían lo mismo:
 * `Onboarding.jsx` caía a `https://aturno-backend.onrender.com` y el resto a
 * `http://localhost:3001`. O sea que en desarrollo el onboarding le pegaba a
 * PRODUCCIÓN: los negocios de prueba se creaban contra la base real, y lo que se
 * arreglaba en el backend local no se veía nunca en ese paso.
 *
 * El valor por defecto es localhost a propósito. En un build de producción
 * `REACT_APP_API_URL` está definida y este fallback no se usa; si falta, es un
 * error de configuración y conviene que se note en desarrollo (el pedido falla
 * contra localhost) en vez de que el build de producción hable en silencio con
 * una URL escrita a mano en el código.
 *
 * `REACT_APP_API_URL` se lee en tiempo de compilación: Create React App la
 * sustituye textualmente, así que cambiarla exige recompilar, no sólo reiniciar.
 */
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default API_URL;
